<div class="dm-page-content mb-25" [attr.aria-busy]="isLoading">
  <div class="container-fluid">
    <app-search-bar primaryBtnLabel="Novo Grupo" (onPrimaryBtnClick)="createNewProfile()" [showFilterBtn]="true"
      (onFilterBtnClick)="showFilter = true">
    </app-search-bar>

    <div class="row">

      <!-- Loading state -->
      <!-- <ng-container *ngIf="isLoading; else contentLoaded">
        <div class="p-3 w-full">
          <p-skeleton height="2.5rem" class="mb-2"></p-skeleton>
          <p-skeleton height="2.5rem" class="mb-2"></p-skeleton>
          <p-skeleton height="2.5rem" class="mb-2"></p-skeleton>
          <p-skeleton height="2.5rem"></p-skeleton>
        </div>
      </ng-container> -->

      <!-- Loaded state -->
      <ng-container *ngIf="pagination?.data?.length; else noGrupos">
        <app-table [pagination]="pagination" [columns]="columns" [actions]="actions" (pageChange)="onPageChange($event)"
          (rowClick)="editGroup($event)">
        </app-table>
      </ng-container>

      <ng-template #noGrupos>
        <div class="no-data">
          <app-data-void titulo="Nenhum grupo encontrado" descricao="Clique em Novo Grupo para criar um.">
          </app-data-void>
        </div>
      </ng-template>
    </div>
  </div>
</div>

<p-dialog [header]="isEditMode ? 'Editar Grupo' : 'Criar Grupo'" [modal]="true" [(visible)]="showModalAddGroup"
  [style]="{ width: '35rem' }" closeIcon="pi pi-times" appendTo="body" (onHide)="resetForm()">
  <form [formGroup]="formAddGroup" class="p-fluid grid">

    <div class="field d-flex flex-column col-12">
      <label for="nomeGrupo">Nome do Grupo</label>
      <input id="nomeGrupo" type="text" pInputText formControlName="nomeGrupo" class="w-full"
        placeholder="Digite o nome do grupo" />
      <div *ngIf="formAddGroup.get('nomeGrupo')?.touched && formAddGroup.get('nomeGrupo')?.invalid">
        <small class="error-message" *ngIf="formAddGroup.get('nomeGrupo')?.errors?.['required']">
          Nome do grupo é obrigatório.
        </small>
      </div>
    </div>
    <div class="field col-12 d-flex flex-column">
          <label for="descricao">Descrição</label>
          <input type="text" pInputText formControlName="descricao" placeholder="Descrição" class="w-100" />
        </div>
  </form>

  <div class="d-flex justify-content-between">
    <p-button label="Cancelar" severity="secondary" (click)="cancel()" [disabled]="isLoading"></p-button>
    <p-button label="Guardar" *ngIf="!isEditMode" (click)="saveGroup()" [loading]="isLoading"
      [disabled]="isLoading || formAddGroup.invalid"></p-button>
    <p-button label="Actualizar" *ngIf="isEditMode" (click)="updateGroup()" [loading]="isLoading"
      [disabled]="isLoading || formAddGroup.invalid"></p-button>
  </div>
</p-dialog>

<p-dialog header="Filtros" [modal]="true" [(visible)]="showFilter" [style]="{ width: '40rem' }" appendTo="body">

  <form [formGroup]="form" class="p-fluid grid">
    <div *ngFor="let filter of filters" class="field col-6 d-flex flex-column">
      <label>{{ filter.placeholder }}</label>

      <!-- Se for dropdown -->
      <p-select *ngIf="filter.type === 'dropdown'" [filter]="true" [showClear]="true" appendTo="body"
        [options]="filter.options" [formControlName]="filter.controlName" [placeholder]="filter.placeholder"
        [optionLabel]="filter.optionLabel" [optionValue]="filter.optionValue">
      </p-select>

      <!-- Se for texto -->
      <input *ngIf="filter.type === 'text'" pInputText [formControlName]="filter.controlName"
        [placeholder]="filter.placeholder" class="w-full" />
    </div>
  </form>

  <div class="flex items-center justify-content-between">
    <p-button label="Cancelar" severity="secondary" (click)="showFilter = false" />
    <p-button label="Pesquisar" (click)="handleFormValueChange(form.value)" />
  </div>
</p-dialog>

<p-toast />
<p-confirmdialog />
